module.exports = __webpack_public_path__ + "img/bg-home-mount.46f816ed.png";